<div #mainBox [class.top-box]="isTopBox" [class.bottom-box]="isBottomBox" class="fluencyrate-box pointer"
    (clickOutside)="onClickOutside()" [additionalElementRefs]="extraBoxes">
    <div class="flag flex-column  no-select" [class.flag-all-trials]="remainingTrials<=0"  (mousedown)="startLongPress()" (mouseup)="endLongPress($event)"
        (mouseleave)="endLongPress($event)" (touchstart)="startLongPress()" (touchend)="endLongPress($event)"
        (touchcancel)="endLongPress($event)" (click)="openFluencyRate()" >

        <span class="badge badge-left badge-big badge-green" (click)="showExtra2()" *ngIf="fluencies.length>0">{{lastFluency()}}</span>
        <div class="duration-container" [class.blinking-effect]="isAlarmRinging">
            <div class="duration-controls">
                <button (click)="startTimer()" class="duration-button start-button">{{timerString()}}</button>
                <button *ngIf="isStarted" (click)="stopTimer()" class="duration-button stop-button">
                    Stop
                </button>
            </div>
            <div class="flag-text">{{ text }}

                <span class="sd-text">{{target?.DiscriminativeStimulus}}</span>

            </div>
        </div>
        <span class="badge-count" (click)="showExtra2()" [class.badge-count-green]="fluencies.length>=expectedAmount"
            [class.badge-count-red]="fluencies.length<expectedAmount">{{fluencies.length}}/{{expectedAmount}}</span>

        <button class="badge-bottom-left" [class.target-note-new]="target?.HasUnreadTargetNoteForStaff" (click)="openDetails($event)" >?</button>
        <button class="badge-bottom-right" (click)="openDetails($event)" title="Remaining desired Trials" *ngIf="remainingTrials>0"> {{remainingTrials}}</button>  
    </div>
</div>
@if (detailsOpened) {
<app-target-details [target]="target" (onCloseDetails)="onCloseDetails()" [isPreview]="isPreview"></app-target-details>
}

<div class="extra-container" #extraBox [class.hide]="!extraOpened">
    <div class="extra-container-textbox">
        <div class="score-buttons">
            <button class="incorrect-button" (click)="incrementIncorrect()">
                <span class="button-count">{{ totalIncorrect }}</span>
                Incorrect
            </button>
            <button class="correct-button" (click)="incrementCorrect()">
                <span class="button-count">{{ totalCorrect }}</span>
                Correct
            </button>
        </div>
    </div>
</div>

<div class="extra-container" #extraBox2 [class.hide]="!extra2Opened">
    <div class="extra-close" (click)="closeExtra2()">X</div>
    <div class="extra-container-textbox">
        <div *ngFor="let fluency of fluencies">
            <div class="float-right extra-list-trash-icon pointer" (click)="deleteData(fluency)"><i class="pi pi-trash"></i></div>
            <div>{{ fluency.FormattedDate }}</div>
            <div>{{fluency.rate.toFixed(0)}}%</div> 
            <div class="score-buttons m-0">
                <button class="incorrect-button">
                    <span class="button-count">{{ fluency.totalIncorrect }}</span>
                    Incorrect
                </button>
                <button class="correct-button">
                    <span class="button-count">{{ fluency.totalCorrect }}</span>
                    Correct
                </button>
            </div>
        </div>
    </div>
</div>
